import { Nullable } from '@utils/util.types';
import { create } from 'zustand';
import { ChatTabType } from '../types';

export interface ChatStore {
	searchQuery: string;
	activeTab: ChatTabType;
	selectedChannelId: Nullable<string>;
	lastMessageChannel: Nullable<string>;
	lastMessageTimestamp: number;
	
	// Message search state
	messageSearchQuery: string;
	isMessageSearchMode: boolean;

	setSearchQuery: (query: string) => void;
	setActiveTab: (tab: ChatTabType) => void;
	setSelectedChannelId: (id: Nullable<string>) => void;
	setLastMessageInfo: (channelId: string) => void;
	
	// Message search functions
	setMessageSearchQuery: (query: string) => void;
	setMessageSearchMode: (isActive: boolean) => void;
	clearMessageSearch: () => void;
}

export const useChatStore = create<ChatStore>((set, get) => ({
	searchQuery: '',
	activeTab: ChatTabType.Direct,
	selectedChannelId: null,
	lastMessageChannel: null,
	lastMessageTimestamp: Date.now(),
	
	// Message search initial state
	messageSearchQuery: '',
	isMessageSearchMode: false,

	setActiveTab: (tab: ChatTabType) => {
		set((state) => ({ ...state, activeTab: tab }));
	},

	setSearchQuery: (query: string) => {
		set((state) => ({ ...state, searchQuery: query }));
	},

	setSelectedChannelId: (id: Nullable<string>) => {
		set((state) => ({ ...state, selectedChannelId: id }));
	},

	setLastMessageInfo: (channelId: string) => {
		set((state) => ({
			...state,
			lastMessageChannel: channelId,
			lastMessageTimestamp: Date.now(),
		}));
	},
	
	// Message search functions
	setMessageSearchQuery: (query: string) => {
		set((state) => ({ ...state, messageSearchQuery: query }));
	},
	
	setMessageSearchMode: (isActive: boolean) => {
		set((state) => ({ 
			...state, 
			isMessageSearchMode: isActive,
			// Clear search query when disabling search mode
			messageSearchQuery: isActive ? state.messageSearchQuery : ''
		}));
	},
	
	clearMessageSearch: () => {
		set((state) => ({ 
			...state, 
			messageSearchQuery: '', 
			isMessageSearchMode: false 
		}));
	},
}));
